import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Icon,
  VStack,
} from '@chakra-ui/react';
import { WarningTwoIcon } from '@chakra-ui/icons';

/**
 * Modal exibido quando a sessão do usuário expira (token inválido/expirado).
 * Bloqueia a interface com overlay até que o usuário clique para ir ao login.
 */
function SessionExpiredModal({ isOpen }) {
  const handleGoToLogin = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {}}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
    >
      <ModalOverlay bg="blackAlpha.700" backdropFilter="blur(4px)" />
      <ModalContent mx={4}>
        <ModalHeader textAlign="center" pt={8}>
          <VStack spacing={3}>
            <Icon as={WarningTwoIcon} boxSize={12} color="orange.400" />
            <Text fontSize="xl" fontWeight="bold">
              Sessão Expirada
            </Text>
          </VStack>
        </ModalHeader>
        <ModalBody textAlign="center" pb={4}>
          <Text color="gray.600">
            Sua autenticação no sistema expirou. Por favor, faça login novamente para continuar.
          </Text>
        </ModalBody>
        <ModalFooter justifyContent="center" pb={8}>
          <Button colorScheme="blue" size="lg" onClick={handleGoToLogin} px={10}>
            Ir para o Login
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default SessionExpiredModal;
